import { bytesToKB } from '../../../utility/helpers';
import { NUMBERS } from '../../../resources/number-constants';
import { DocxIcon, pdfIcon, profileImg } from '../../../assets/images/images';

const itemLabels: any = {
    // canonical keys -> display labels
    work_on: 'What would you work on?',
    could_have: 'Could-Haves',
    good_to_have: 'Good-to-Haves',
    must_have: 'Must-Haves',
    should_have: 'Should-Haves'
};

const OutgoingText = ({
    chat,
    companyLogo,
    isFromJob = false
}: any) => {
    const renderTitle = () => {
        if (Array.isArray(chat?.payload?.title)) {
            return chat.payload.title.join(', ');
        } else if (!chat?.payload?.title && chat?.payload?.message) {
            return chat?.payload?.message;
        } else if (chat?.payload?.title && !chat?.payload?.message) {
            return Object.values(chat?.payload?.title)[0];
        }
        const title = chat?.payload?.title;
        if (typeof title === 'string') {
            // Try key-based mapping first (e.g., "work_on", "could_have")
            if (itemLabels[title]) return itemLabels[title];
            // Then try to map by case-insensitive match against known labels
            const matchByLabel = (Object.values(itemLabels) as string[]).find(
                (label) => label.toLowerCase() === title.toLowerCase()
            );
            return matchByLabel || title;
        }
        return title;
    };

    const renderDocument = (name?: string, size?: number, urlForCheck?: string) => (
        <div className='chat-document-wrap'>
            {(urlForCheck || name || '').toLowerCase().endsWith('.pdf') ? (
                <img src={pdfIcon} alt="document" className='document-img' />
            ) : (
                <img src={DocxIcon} alt="document" className='document-img' />
            )}
            <span className='document-name'>{name || ''}</span>
            <span className='document-size'>{bytesToKB(size || 0)}</span>
        </div>
    );

    const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = profileImg;
    };
    return (
        <>
            <div className="outgoing_msg">
                <div className="sent_msg">
                    {(chat?.payload_type === NUMBERS.THREE) && (
                        <p>{renderTitle()}</p>
                    )}

                    {(chat?.payload_type === 1) && (
                        <div>{renderDocument(chat?.file_name, chat?.file_size, chat?.file_name)}</div>
                    )}
                    {(chat?.payload_type === NUMBERS.TWO) && (
                        <div>{renderDocument(chat?.file_name, chat?.file_size, chat?.file_url)}</div>
                    )}
                </div>
                    <div className={`outgoing_msg_img ${isFromJob ? 'd-none' : ''}`}>
                        <img
                            src={companyLogo || profileImg}
                            alt="user"
                            onError={handleImageError}
                            loading="lazy"
                            className="chat-user-profile-img"
                        />
                    </div>
            </div>
        </>
    );
};

export default OutgoingText;
